/** Matches MyTrace's samplePurpose values (phase3_salesOrders.js) — buyer / staff / event. */
export const SAMPLE_PURPOSES = ['buyer', 'staff', 'event'];
//# sourceMappingURL=sample-purpose.js.map